// Central API fetch wrapper (#206).
//
// Every call made through apiFetch() carries an `x-correlation-id` header. The backend's
// CorrelationIdMiddleware reads it and stamps it onto every log line as `correlation_id`, so
// one booking journey -- page load, availability check, create-order, complete-order -- becomes
// a single greppable id instead of reconstructed by eye from timestamps, as the 30 July
// incident had to be.
//
// The id is rotated once per page view -- see rotateCorrelationId, called by
// RouteChangeTracker on every route change.

function createCorrelationId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

let currentCorrelationId = createCorrelationId();

/** Mint a fresh correlation id (call on each page view). Returns the new id. */
export function rotateCorrelationId() {
    currentCorrelationId = createCorrelationId();
    return currentCorrelationId;
}

/** The correlation id currently attached to outgoing requests. */
export function getCorrelationId() {
    return currentCorrelationId;
}

/**
 * fetch() wrapper that adds the current x-correlation-id header.
 * A caller-supplied x-correlation-id is respected if already present.
 */
export function apiFetch(input, init = {}) {
    const headers = new Headers(init.headers || {});
    if (!headers.has('x-correlation-id')) {
        headers.set('x-correlation-id', currentCorrelationId);
    }
    return fetch(input, { ...init, headers });
}
